import styled, { css } from "styled-components";

export const PopupContentWrapper = styled.div`
  z-index: 1000;
  height: max-content;
  width: max-content;
  pointer-events: none;
`;

export const PopupContent = styled.div<{ $unstyled?: boolean }>`
  position: relative;
  pointer-events: all;
  display: flex;
  flex-direction: column;
  z-index: 30;

  ${({ $unstyled, theme }) =>
    !$unstyled &&
    css`
      padding: 12px;
      gap: 6px;
      border-radius: 16px;
      background: ${({ theme }) => theme.colors.base};
      color: ${({ theme }) => theme.colors.default.default};
      border: 1px solid ${({ theme }) => theme.colors.default[100]};
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);

      ${theme.breakpoints.sm.query} {
        border-radius: 12px 12px 0 0;
      }
    `}
`;

export const PopupBtn = styled.div<{ $unstyled?: boolean }>`
  ${({ $unstyled }) =>
    !$unstyled &&
    css`
      width: 100%;
      height: 100%;
    `}
`;

export const MobilePopupContentWrapper = styled.div`
  z-index: 1000;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;

  &::before {
    content: "";
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    pointer-events: none;
    background: ${({ theme }) => theme.colors.default.default};
    opacity: 0.5;
  }
`;
